import { Icon, Icons } from "@phoenix/components/icon";

export const FieldSuccessIcon = () => {
  return (
    <Icon color="success" className="field__icon" svg={<Icons.Checkmark />} />
  );
};
